module.exports = __webpack_public_path__ + "img/icon_ohne_rand.97f2752.svg";